const LIVE_GAME_STATUSES = new Set(["1", "true", "live", "in_progress", "in-progress", "inprogress"]);

const isLiveGame = (game) => {
  const value = game?.is_live ?? game?.status ?? game?.game_status ?? "";

  if (value === true || value === 1) {
    return true;
  }

  return LIVE_GAME_STATUSES.has(String(value || "").trim().toLowerCase());
};

const getEventAvailabilityKey = (game, sport = "") => (
  `${String(game?._topPlaysLeague || sport || "").trim().toLowerCase()}|${String(game?.id || game?.game_id || "")}`
);

const filterRejectedEvents = (games, rejectedEvents = {}, sport = "", now = Date.now()) => (
  (Array.isArray(games) ? games : []).filter((game) => (
    !(Number(rejectedEvents[getEventAvailabilityKey(game, sport)]) > now)
  ))
);

// Fresh event-rail results outrank an independently cached league badge.
const reconcileLiveSports = (leagues, railStates = {}, now = Date.now()) => {
  const live = Array.isArray(leagues) ? leagues.slice() : [];
  Object.keys(railStates).forEach((sport) => {
    const state = railStates[sport];
    if (now - state.observedAt > 90 * 1000) return;
    const index = live.indexOf(sport);
    if (state.isLive && index < 0) live.push(sport);
    else if (!state.isLive && index >= 0) live.splice(index, 1);
  });
  return live;
};

module.exports = { isLiveGame, getEventAvailabilityKey, filterRejectedEvents, reconcileLiveSports };
